import React, { useState } from 'react';
import '../../App.css';
import { AppHeader, AvatarSelector , HeaderIcons } from '../shared';
import Footer from '../shared/Footer';
import { avatars } from '../../assets/avatars';
import { useTranslation } from '../../i18n';

interface PhoneOnlySetupProps {
  onContinue: (playerName: string, avatar: string) => void;
  onBack: () => void;
}

const PhoneOnlySetup: React.FC<PhoneOnlySetupProps> = ({ onContinue, onBack }) => {
  const [playerName, setPlayerName] = useState('');
  const [selectedAvatar, setSelectedAvatar] = useState(avatars[0]);
  const { t } = useTranslation();

  const handleContinue = () => {
    if (!playerName.trim()) {
      return;
    }
    onContinue(playerName.trim(), selectedAvatar);
  };

  return (
    <div className="app" style={{ position: 'relative', paddingBottom: '100px' }}>
      <AppHeader
        logo={null}
        leftButton={{
          icon: HeaderIcons.back,
          onClick: onBack,
          tooltip: t('common.backToHome')
        }}
      />
      <div className="container player-content-wrapper" style={{ marginTop: '5px', marginBottom: '100px' }}>
        <p className="subtitle">{t('lobby.phoneOnlySetup.subtitle')}</p>

        <div style={{ width: '100%', maxWidth: '100%' }}>
          <label className="form-label">
            {t('common.yourName')}
          </label>
          <input
            type="text"
            className="input"
            placeholder={t('common.enterYourName')}
            value={playerName}
            onChange={(e) => {
              setPlayerName(e.target.value);
            }}
            style={{
              fontSize: '1rem',
            }}
          />

          <AvatarSelector
            selectedAvatar={selectedAvatar}
            onSelect={setSelectedAvatar}
          />
        </div>
      </div>
      <Footer>
        <div style={{
          display: 'flex',
          gap: '1rem',
          width: '100%',
          maxWidth: '1600px',
          margin: '0 auto',
        }}>
          <button
            className="button"
            onClick={onBack}
            style={{
              flex: 1,
              backgroundColor: 'rgba(248, 250, 252, 0.2)',
              fontSize: '1.3rem',
              padding: '1.2rem',
            }}
          >
            {t('common.back')}
          </button>
          <button
            className="button"
            onClick={handleContinue}
            disabled={!playerName.trim()}
            style={{
              flex: 2,
              backgroundColor: 'var(--color-primary)',
              opacity: !playerName.trim() ? 0.5 : 1,
              cursor: !playerName.trim() ? 'not-allowed' : 'pointer',
              fontSize: '1.3rem',
              padding: '1.2rem',
            }}
          >
            {t('common.continue')}
          </button>
        </div>
      </Footer>
    </div>
  );
};

export default PhoneOnlySetup;
